import React from 'react';

export function HandlingSometingWentWrong(parent) {
    if(parent === 'table') {
        return (
            <tr>
                <td className="table-not-found" colSpan="100%">
                    <span className="fa fa-frown-o"></span>&nbsp;Something went wrong
                    <div className="text-muted suggestions-list">
                        <p>Try :</p>
                        <ul>
                            <li>
                                Refresh this page
                            </li>
                            <li>
                                Reconnecting to Wi-Fi
                            </li>
                            <li>
                                Checking the network cables, modem, and router
                            </li>

                        </ul>
                    </div>
                </td>
            </tr>
        )
    } else {
        return (
            <div>
                <span className="fa fa-frown-o"></span>&nbsp;Something went wrong
                <div className="text-muted suggestions-list">
                    <p>Try :</p>
                    <ul>
                        <li>
                            Refresh this page
                        </li>
                        <li>
                            Reconnecting to Wi-Fi
                        </li>
                        <li>
                            Checking the network cables, modem, and router
                        </li>

                    </ul>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/App/utils/HandlingMessage.js